<script lang="ts">
	import Button from '#lib/html/button/Button.svelte';
	import type { Snippet } from 'svelte';
	import GlassEffect from './GlassEffect.svelte';

	interface Props {
		onclick?: () => void;
		title?: string;
		tooltip?: string;
		description?: string;
		icon?: string;
		disabled?: boolean;
		children?: Snippet;
		className?: string;
		color?: string | number;
		zoom?: boolean;
		iconLeft?: boolean;
		showBorder?: boolean;
		iconSizeClasses?: string;
		padding?: string;
		pulse?: boolean;
		elt?: HTMLElement;
		legacyDesign?: boolean;
	}
	let {
		onclick = undefined,
		title = '',
		tooltip = '',
		description = '',
		icon = '',
		disabled = false,
		children = undefined,
		className = '',
		color = 'transparent',
		zoom = false,
		iconLeft = false,
		showBorder = false,
		iconSizeClasses = 'w-4 h-4 flex-none',
		pulse = false,
		padding = 'p-2',
		elt = $bindable(),
		legacyDesign = false
	}: Props = $props();

	let realColor = $derived(!legacyDesign && disabled ? 'transparent' : color);
</script>

<div
	title={tooltip || undefined}
	class="text-left text-sm
	{className}
	{disabled ? 'cursor-not-allowed' : ''}
	{onclick && !disabled ? 'cursor-pointer' : ''}
	{showBorder ? 'border border-surface/30 dark:border-surface/20 rounded-xl' : ''}
	{pulse ? 'relative' : ''}"
	{onclick}
	bind:this={elt}
	role="button"
	tabindex="0"
	onkeydown={onclick}
>
	<GlassEffect
		color={legacyDesign && disabled ? 10 : realColor}
		className="
			{realColor === 'transparent' ? '' : 'px-2'}
			rounded-2xl hover:opacity-50 transition-opacity border-surface/30 w-full
			{!legacyDesign && disabled ? 'bg-surface/10 opacity-50' : ''}
			"
		transparent={realColor === 'transparent'}
	>
		<Button
			title={tooltip || undefined}
			iconPosition={iconLeft ? 'left' : 'right'}
			{iconSizeClasses}
			{icon}
			disableHoverBgColor
			{zoom}
			{onclick}
			{disabled}
			bgDisabledColor="transparent"
			className="w-full"
			{padding}
		>
			{@render children?.()}
			{#if title}
				{#if description}
					<div class="flex flex-col text-left">
						<span>{title}</span>
						<span class="text-xs opacity-70 font-normal">{description}</span>
					</div>
				{:else}
					{title}
				{/if}
			{/if}
		</Button>
	</GlassEffect>
	{#if pulse}
		<div
			class="absolute top-1 right-1 flex items-center justify-center w-[9px] h-[9px] rounded-full"
		>
			<div class="absolute bg-error rounded-full w-5 h-5 animate-ping"></div>
			<div class="absolute bg-surface/50 rounded-full w-3 h-3 animate-ping"></div>
			<div
				class="absolute bg-error rounded-full w-2 h-2 border border-surface dark:border-surface/70"
			></div>
		</div>
	{/if}
</div>
